<template>
  <div class="box">
    <sidebar
      style="width: 19%"
      :sidList="sidList"
      @sibIndex="getSibItem"
    ></sidebar>
    <div class="content">
      <currentLocation :sibItem="sibItem"></currentLocation>
      <div>
        <articleList
          :currentPage="currentPage"
          :page-size="pageSize"
          :articleList="articleList"
          :total="total"
          v-on:func="getSocietyItemList"
          type="1"
          v-if="isShowDetail == 0"
        ></articleList>

        <articleDetails
          v-if="isShowDetail == 1"
          :articleInfo="articleInfo"
          type="1"
        ></articleDetails>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * Created by www.xingnuocn.com
 * @title：社会服务
 *
 * @author: 刘嘉鑫
 * @version  V1.0
 * @datecreate: 2022-04-02 14:38
 */
import sidebar from "@/components/sidebar.vue"; // 侧边栏
import currentLocation from "@/components/currentLocation.vue"; // 当前位置
import articleList from "@/views/articleList.vue"; // 文章列表
import articleDetails from "@/views/articleDetails.vue"; // 文章详情
export default {
  components: { sidebar, currentLocation, articleDetails, articleList },
  data() {
    return {
      sidList: [
        {
          title: "技术服务",
          index: 0,
          type: 1,
        },
        {
          title: "环保教育",
          index: 1,
          type: 2,
        },
        {
          title: "应用推广",
          index: 2,
          type: 3,
        },
      ],
      sibItem: {
        title: "技术服务",
        index: 0,
        type: 1,
      },

      articleInfo: {},

      currentPage: 1, // 分页第几页
      pageSize: 20,
      total: 0,
      articleList: [],

      isShowDetail: 0,

      timer: new Date().getTime(),
    };
  },
  mounted() {
    this.getSocietyItemList(1);
  },
  methods: {
    // 侧边栏传参
    getSibItem(item) {
      console.log(item);
      this.sibItem = item;
      this.articleList = [];
      this.isShowDetail = 0;
      this.getSocietyItemList(1);
    },

    getSocietyItemList(page) {
      let that = this;
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/json",
          // "Content-Type": "application/x-www-form-urlencoded",
        }, // 请求头
        url: `${this.$root.baseUrl}/Society/getSocietyItemList`,
        data: {
          type: that.sibItem.type, // 1技术服务 2环保教育 3应用推广
          page: page,
        },
      }).then((result) => {
        // console.log("文章详情", result.data);
        if (result.data.code == 1) {
          that.articleList = result.data.data.list;
          that.total = result.data.data.total_count;
        }
      });
    },

    // 跳转详情
    articleDetails(item) {
      let that = this;
      this.isShowDetail = 1;
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/json",
          // "Content-Type": "application/x-www-form-urlencoded",
        }, // 请求头
        url: `${this.$root.baseUrl}/Common/getArticleInfo`,
        data: {
          article_id: item.article_id,
        },
      }).then((result) => {
        // console.log("文章详情", result.data);
        if (result.data.code == 1) {
          that.articleInfo = result.data.data;
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.box {
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
}

.content {
  width: 80%;
  padding: 0 32px 0 29px;
}
</style>